// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson <hi@ben.gy>
// Additional permissions under AGPL-3.0 section 7 apply — see ADDITIONAL-TERMS.md.

/** Jargon → plain-English definitions for click-to-define tooltips. */
export const GLOSSARY: Record<string, string> = {
  'orientation sensor':
    'The combination of tiny sensors in your phone (accelerometer and gyroscope) that knows which way it is pointing and how it is tilted — the same chips that rotate your screen. Tiltwell reads them many times a second to feel the exact angle the phone is held at.',
  'spirit level':
    'A tool for checking whether a surface is truly horizontal (level) or vertical (plumb). The classic version has a bubble in a curved glass vial that sits dead-centre when the surface is level; Tiltwell draws a digital one.',
  plumb:
    'Perfectly vertical — straight up and down, the direction a hanging weight (a plumb bob) settles to. The vertical counterpart of "level".',
  level:
    'Perfectly horizontal — the direction still water sits at. A shelf is level when neither end is higher than the other.',
  inclinometer:
    'An instrument that measures an angle of slope or tilt from horizontal — also called a clinometer. Roofers, surveyors and pilots use them.',
  'roof pitch':
    'How steep a roof is, quoted as rise-per-run over 12 — a "5:12" roof rises 5 units for every 12 across. Tiltwell converts a measured angle straight into this.',
  grade:
    'The steepness of a slope as a percentage: rise divided by run, times 100. A 100 % grade is a 45° slope; a wheelchair ramp is usually kept under about 8 %.',
  ratio:
    'A slope written as 1:n — one unit of rise for every n units of run. A 1:12 ramp climbs 1 cm for every 12 cm travelled. Smaller n means steeper.',
  beta:
    'The front-to-back tilt angle reported by the browser’s orientation event — how far the phone is pitched toward or away from you.',
  gamma:
    'The left-to-right tilt angle reported by the browser’s orientation event — how far the phone is rolled onto its side.',
  calibrate:
    'Telling Tiltwell that "right now" counts as zero, so it measures the tilt relative to the surface you are on rather than to true horizontal. Useful for checking whether one thing is level with another.',
  tolerance:
    'How close to perfectly level still counts as "level". Inside the tolerance the bubble turns green; outside it turns amber.',
  protractor:
    'A tool for measuring an angle drawn on a flat surface. Tiltwell’s photo mode is a digital protractor: tap points on a photo and it reads the angle between them.',
};
